module.exports = __webpack_public_path__ + "img/arrow-up-right-and-arrow-down-left-from-center.2f6e7aed.svg";